import { useTranslation } from 'react-i18next'
import { Search } from 'lucide-react'

export interface LoginHeaderProps {
  /** Current step of the login flow — drives the displayed title and subtitle. */
  step: 'credentials' | 'totp'
}

/**
 * Public login branding header: round logo badge plus a title/subtitle pair
 * whose copy depends on the active step (credentials vs. two-factor). Pure
 * presentation — no state of its own.
 */
export function LoginHeader({ step }: LoginHeaderProps) {
  const { t } = useTranslation()
  return (
    <div className="text-center">
      <div className="mx-auto h-14 w-14 rounded-full bg-primary flex items-center justify-center mb-4">
        <Search className="h-6 w-6 text-primary-foreground" />
      </div>
      {step === 'credentials' ? (
        <>
          <h1 className="font-serif text-3xl font-bold">{t('auth.login_title')}</h1>
          <p className="text-muted-foreground mt-2 text-sm">{t('auth.login_subtitle')}</p>
        </>
      ) : (
        <>
          <h1 className="font-serif text-3xl font-bold">{t('auth.two_factor_title')}</h1>
          <p className="text-muted-foreground mt-2 text-sm">{t('auth.two_factor_subtitle')}</p>
        </>
      )}
    </div>
  )
}
